// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resource-details-page {
  padding: 0 1rem 2rem;
}

.resource-details-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

.resource-details-back-button {
  background-color: transparent;
  border: 1px solid var(--secondary-color);
  border-radius: 0.5rem;
  color: var(--secondary-color);
  cursor: pointer;
  padding: 0.65rem 1.25rem;
}

.resource-details-back-button:hover {
  background-color: var(--secondary-color);
  color: #ffffff;
}

.resource-details-section {
  background-color: #ffffff;
  border: 1px solid #d7e0e8;
  border-radius: 0.75rem;
  margin-bottom: 1.5rem;
  padding: 1.25rem;
}

.resource-details-card {
  background-color: #f7faff;
  border: 1px solid #dce8f4;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  height: 100%;
  min-height: 6.5rem;
  padding: 1.25rem;
}

.resource-details-static-card {
  cursor: default;
}

.resource-details-static-card:hover {
  background-color: #f7faff;
  border-color: #dce8f4;
  box-shadow: none;
  transform: none;
}

.resource-details-label {
  color: #5d738a;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.resource-details-value {
  color: #173a5e;
  font-size: 1rem;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.resource-details-list {
  color: #173a5e;
  font-weight: 600;
  margin: 0;
  padding-left: 1.25rem;
}

.resource-details-list li + li {
  margin-top: 0.4rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResourceDetailsPage/EncounterDetailsPage/EncounterDetailsPage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".resource-details-page {\n  padding: 0 1rem 2rem;\n}\n\n.resource-details-toolbar {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 1rem;\n}\n\n.resource-details-back-button {\n  background-color: transparent;\n  border: 1px solid var(--secondary-color);\n  border-radius: 0.5rem;\n  color: var(--secondary-color);\n  cursor: pointer;\n  padding: 0.65rem 1.25rem;\n}\n\n.resource-details-back-button:hover {\n  background-color: var(--secondary-color);\n  color: #ffffff;\n}\n\n.resource-details-section {\n  background-color: #ffffff;\n  border: 1px solid #d7e0e8;\n  border-radius: 0.75rem;\n  margin-bottom: 1.5rem;\n  padding: 1.25rem;\n}\n\n.resource-details-card {\n  background-color: #f7faff;\n  border: 1px solid #dce8f4;\n  border-radius: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  height: 100%;\n  min-height: 6.5rem;\n  padding: 1.25rem;\n}\n\n.resource-details-static-card {\n  cursor: default;\n}\n\n.resource-details-static-card:hover {\n  background-color: #f7faff;\n  border-color: #dce8f4;\n  box-shadow: none;\n  transform: none;\n}\n\n.resource-details-label {\n  color: #5d738a;\n  font-size: 0.85rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.resource-details-value {\n  color: #173a5e;\n  font-size: 1rem;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.resource-details-list {\n  color: #173a5e;\n  font-weight: 600;\n  margin: 0;\n  padding-left: 1.25rem;\n}\n\n.resource-details-list li + li {\n  margin-top: 0.4rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
